import { useMutation } from 'react-query';

import { GAMFAEnable } from '../../lib/api';

export function useMutateEnableGaMfa() {
  return useMutation(GAMFAEnable);
}
